import React from 'react';
import './modal.css';

const ViewModal = ({ isOpen, closeModal, children, title, button, zIndex }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal" style={zIndex ? { zIndex } : undefined}>
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">{title}{button}</h4>
          <span className="close" onClick={closeModal}>&times;</span>
        </div>

        {children}
      </div>
    </div>
  );
};

export default ViewModal;
